import { useNavigate, useSearchParams } from "react-router-dom";
import SC from "./style";
import theme from "@theme/";
import { formatFileSize } from "utils/helper";
import { Button, DetailDrawer } from "@InnoUI/";
import TimezoneConverter from "components/TimeZoneConvertor";
import { Checkbox } from "antd";
import { HighlightedText } from "@components/";
import { ReadMoreHtmlText } from "@InnoInput/";
import FileDetailsView from "views/ProjectHome/ListFileAndPermission/FileDetailsView";
import { useState } from "react";
import PointIdIndicator from "components/PointIdIndicator";

const DocumentCard = (props) => {
  const {
    file,
    selectedItems,
    setSelectedItems,
    partialSearch,
    searchKey,
    chatUI = false,
  } = props;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const [open, setOpen] = useState(false);
  const [fileData, setFileData] = useState({});

  const handleViewClick = (data) => {
    navigate(
      `/document/file-details?projectId=${projectId}&fileId=${data.id}&parentId=${data.parentId}&folderId=${data.folderId}&type=${type}`,
    );
  };

  const checkboxChange = (file, isChecked) => {
    const fileId = file.id;

    if (isChecked) {
      setSelectedItems((prev) =>
        prev.includes(fileId) ? prev : [...prev, fileId],
      );
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== fileId));
    }
  };
  const handleHierarchyClick = (data) => {
    if (!data?.id) return;
    const url = `/document?projectId=${data.projectId}&folderId=${data.folderId}&fileId=${data.id}&type=${data.projectType}`;
    if (chatUI) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  };

  const handleViewDrawerClick = (data) => {
    setOpen(true);
    setFileData(data);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  return (
    <>
      <SC.Content key={file.id}>
        <SC.RowWrapper style={{ width: "100%" }}>
          <SC.ColumnMore>
            <Button
              caption={"View"}
              onClick={() => handleViewDrawerClick(file)}
              color="white"
              fontSize="12px"
              style={{
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "40px",
                height: "22px",
                borderRadius: theme.modernTokens.borderRadius.md,
                textTransform: "normal",
                fontWeight: 500,
                border: "none",
                boxShadow: theme.modernTokens.shadows.sm,
                transition: theme.modernTokens.transitions.normal,
              }}
            />
          </SC.ColumnMore>

          <SC.ColumnDescription>
            <div style={{ display: "flex", alignItems: "center" }}>
              {file?.knowledgeStatus ? (
                <PointIdIndicator knowledgeStatus={file?.knowledgeStatus} />
              ) : null}

              <SC.FolderHierachy
                style={{ cursor: "pointer" }}
                onClick={() => handleHierarchyClick(file)}
              >
                <HighlightedText
                  text={file?.folderHierarchy}
                  searchText={searchKey}
                  partialSearch={partialSearch}
                />
              </SC.FolderHierachy>
            </div>
            <SC.ChildContainer>
              <SC.Span>
                <HighlightedText
                  text={file?.subject}
                  searchText={searchKey}
                  partialSearch={partialSearch}
                />
              </SC.Span>{" "}
              -{" "}
              <SC.FileName>
                <HighlightedText
                  text={file?.fileName}
                  searchText={searchKey}
                  partialSearch={partialSearch}
                />
              </SC.FileName>
            </SC.ChildContainer>
          </SC.ColumnDescription>

          {/* 🔹 Group meta fields so they reflow nicely on mobile */}
          <SC.MetaBlock>
            <SC.ColumnSize style={{ textAlign: "center" }}>
              {formatFileSize(file?.fileSize)}
            </SC.ColumnSize>
            <SC.ColumCreatedBy style={{ textAlign: "center" }}>
              {file?.createdByName}
            </SC.ColumCreatedBy>
            <SC.ColumRivision style={{ textAlign: "center" }}>
              {file?.revisionId}
            </SC.ColumRivision>
            <SC.ColumnDate>
              <TimezoneConverter time={file.createdOn} />
            </SC.ColumnDate>
          </SC.MetaBlock>

          <SC.ColumnCart>
            <Checkbox
              checked={selectedItems.includes(file.id)}
              onChange={(e) => checkboxChange(file, e.target.checked)}
            />
          </SC.ColumnCart>
        </SC.RowWrapper>

        {!chatUI && (
          <SC.Note>
            <ReadMoreHtmlText
              html={file?.note}
              maxChars={200}
              searchText={searchKey}
            />
          </SC.Note>
        )}
      </SC.Content>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          closable={true}
          width={"80%"}
          children={
            <FileDetailsView
              fileData={fileData}
              onClose={closeDrawer}
              isDrawer={true}
            />
          }
        />
      )}
    </>
  );
};

export default DocumentCard;
